/* RG FAQ Interaction */
document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.rg-faq__item');

    faqItems.forEach(item => {
        const button = item.querySelector('.rg-faq__button');
        const content = item.querySelector('.rg-faq__content');

        button.addEventListener('click', () => {
            const isActive = item.classList.contains('is-active');

            // Close all others
            faqItems.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.classList.remove('is-active');
                    const otherContent = otherItem.querySelector('.rg-faq__content');
                    otherContent.style.maxHeight = null;
                }
            });

            // Toggle current
            if (isActive) {
                item.classList.remove('is-active');
                content.style.maxHeight = null;
            } else {
                item.classList.add('is-active');
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});
